module.exports = __webpack_public_path__ + "img/Avatar-53.b7b7d073.svg";